import { render, staticRenderFns } from "./RegisterModuleQuizQuestion.vue?vue&type=template&id=6a6c44bc&scoped=true&"
import script from "./RegisterModuleQuizQuestion.vue?vue&type=script&lang=js&"
export * from "./RegisterModuleQuizQuestion.vue?vue&type=script&lang=js&"
import style0 from "./RegisterModuleQuizQuestion.vue?vue&type=style&index=0&id=6a6c44bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6c44bc",
  null
  
)

export default component.exports